// @flow
import React from "react";
import { type IconProps } from "../";

export default function ColorfulCup({
  fill = "currentColor",
  width = "28px",
  className,
  ...props
}: IconProps) {
  return (
    <svg
      viewBox="0 0 28.008 34.232"
      fill={fill}
      width={width}
      className={className}
      {...props}
    >
      <g transform="translate(-46.545 0.001)">
        <path
          fill="#9792a1"
          d="M135.035,385.556A1.561,1.561,0,0,0,133.479,384h-15.56a1.561,1.561,0,0,0-1.556,1.556v3.89h18.672Z"
          transform="translate(-65.15 -358.327)"
        />
        <path
          fill="#7c7688"
          d="M114.1,465.455a.837.837,0,0,1,.778.778v1.556a.837.837,0,0,1-.778.778H93.869a.837.837,0,0,1-.778-.778v-1.556a.837.837,0,0,1,.778-.778Z"
          transform="translate(-43.434 -434.336)"
        />
        <path
          fill="#f6b545"
          d="M184.66,314.036a.735.735,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v2.567a.735.735,0,0,1-.778.778.735.735,0,0,0-.778.778v.778h10.892v-.778A.735.735,0,0,0,184.66,314.036Z"
          transform="translate(-119.443 -289.919)"
        />
        <path
          fill="#787382"
          d="M319.627,389.446v-3.89A1.561,1.561,0,0,0,318.071,384h-3.89v5.446Z"
          transform="translate(-249.742 -358.327)"
        />
        <path
          fill="#ffcb5b"
          d="M193.961,410.384h-6.224a1.561,1.561,0,0,1-1.556-1.556h0a1.561,1.561,0,0,1,1.556-1.556h6.224a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,193.961,410.384Z"
          transform="translate(-130.3 -380.043)"
        />
        <g transform="translate(59.771 27.229)">
          <path
            fill="#f6b545"
            d="M245.92,410.385h-1.556l1.556-3.112h1.556Z"
            transform="translate(-244.364 -407.273)"
          />
          <path
            fill="#f6b545"
            d="M282.384,408.828a1.561,1.561,0,0,0-1.556-1.556l-1.556,3.112h1.556A1.56,1.56,0,0,0,282.384,408.828Z"
            transform="translate(-276.938 -407.272)"
          />
        </g>
        <path
          fill="#635d6e"
          d="M114.1,465.455h-5.446v.778a1.561,1.561,0,0,1-1.556,1.556H94.648a.735.735,0,0,1-.778-.778v-1.556a.735.735,0,0,0-.778.778v1.556a.78.78,0,0,0,.778.778H114.1a.837.837,0,0,0,.778-.778v-1.556A.837.837,0,0,0,114.1,465.455Z"
          transform="translate(-43.435 -434.336)"
        />
        <path
          fill="#ffcb5b"
          d="M186.571,360.727H188.9a.368.368,0,0,1,.389.389h0a.367.367,0,0,1-.389.389h-2.334a.367.367,0,0,1-.389-.389h0A.368.368,0,0,1,186.571,360.727Z"
          transform="translate(-130.301 -336.61)"
        />
        <path
          fill="#f6b545"
          d="M53.547,82.267H51.758A3.649,3.649,0,0,1,49.035,81.1l-1.323-1.323a3.532,3.532,0,0,1-1.167-2.723v-4.9a2.292,2.292,0,0,1,2.334-2.334h3.89a.778.778,0,0,1,0,1.556h-3.89a.735.735,0,0,0-.778.778v4.9a2.119,2.119,0,0,0,.7,1.634l1.323,1.323a2.239,2.239,0,0,0,1.634.7h1.789a.778.778,0,0,1,0,1.556Z"
          transform="translate(0 -65.152)"
        />
        <path
          fill="#f6b545"
          d="M351.658,82.268h-1.789a.778.778,0,1,1,0-1.556h1.789a2.119,2.119,0,0,0,1.634-.7l1.323-1.323a2.239,2.239,0,0,0,.7-1.634v-4.9a.735.735,0,0,0-.778-.778h-3.89a.778.778,0,1,1,0-1.556h3.89a2.292,2.292,0,0,1,2.334,2.334v4.9a3.649,3.649,0,0,1-1.167,2.723L354.381,81.1A3.532,3.532,0,0,1,351.658,82.268Z"
          transform="translate(-282.318 -65.153)"
        />
        <g transform="translate(66.773 4.667)">
          <path
            fill="#f19920"
            d="M352.2,231.564c-.156,0-.311.078-.545.078h-1.789a.778.778,0,1,0,0,1.556h2.1a5.529,5.529,0,0,0,.233-1.634Z"
            transform="translate(-349.091 -220.75)"
          />
          <path
            fill="#f19920"
            d="M360.727,70.6a.735.735,0,0,0,.778.778h1.556V69.818H361.5A.735.735,0,0,0,360.727,70.6Z"
            transform="translate(-359.949 -69.818)"
          />
        </g>
        <path
          fill="#ffca5d"
          d="M149.75,64.439h-4.668a5.413,5.413,0,0,1-5.446-5.446V46.545H155.2V58.993A5.412,5.412,0,0,1,149.75,64.439Z"
          transform="translate(-86.867 -43.434)"
        />
        <g transform="translate(56.659 7.001)">
          <path
            fill="#f19920"
            d="M206.376,314.036a.837.837,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v.778a5.017,5.017,0,0,0,1.556.233h2.334a1.561,1.561,0,0,1,1.556,1.556h0a.78.78,0,0,0,.778.778.735.735,0,0,1,.778.778v.778h2.334v-.778A.78.78,0,0,0,206.376,314.036Z"
            transform="translate(-197.818 -296.92)"
          />
          <path
            fill="#f19920"
            d="M454.6,105.116v3.112a.367.367,0,0,1-.389.389h0a.367.367,0,0,1-.389-.389v-3.112a.367.367,0,0,1,.389-.389h0A.368.368,0,0,1,454.6,105.116Z"
            transform="translate(-436.703 -104.727)"
          />
        </g>
        <g transform="translate(51.213 -0.001)">
          <path
            fill="#f6b545"
            d="M139.636,46.545v.778h10.892a1.561,1.561,0,0,1,1.556,1.556V58.993c0,3.034-1.634,5.446-4.668,5.446h2.334a5.413,5.413,0,0,0,5.446-5.446V46.545Z"
            transform="translate(-138.08 -43.433)"
          />
          <path
            fill="#f6b545"
            d="M133.479,3.111h-15.56a1.561,1.561,0,0,1-1.556-1.556h0A1.561,1.561,0,0,1,117.919,0h15.56a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,133.479,3.111Z"
            transform="translate(-116.363 0.001)"
          />
        </g>
        <path
          fill="#f19920"
          d="M133.48,0h0a1.561,1.561,0,0,1-1.556,1.556h-15.56a1.561,1.561,0,0,0,1.556,1.556H133.4a1.665,1.665,0,0,0,1.634-1.323A1.576,1.576,0,0,0,133.48,0Z"
          transform="translate(-65.151 -0.001)"
        />
        <g transform="translate(54.325 5.445)">
          <path
            fill="#ffe27a"
            d="M163.687,87.679h0a.735.735,0,0,1-.778-.778V82.233a.735.735,0,0,1,.778-.778h0a.735.735,0,0,1,.778.778V86.9A.735.735,0,0,1,163.687,87.679Z"
            transform="translate(-162.909 -81.455)"
          />
          <circle
            fill="#ffe27a"
            cx="0.778"
            cy="0.778"
            r="0.778"
            transform="translate(0 7.002)"
          />
        </g>
        <path
          fill="#847f8e"
          d="M117.919,384a1.561,1.561,0,0,0-1.556,1.556v3.89h1.556Z"
          transform="translate(-65.15 -358.327)"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/ColorfulCup.js